<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="话题名称：" prop="topic_name">
                <el-input v-model="model.topic_name"></el-input>
            </el-form-item>
            <el-form-item label="话题描述：" prop="topic_desc">
                <el-input type="textarea" v-model="model.topic_desc" rows="4"></el-input>
            </el-form-item>
            <el-form-item label="话题封面：" prop="topic_img" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.topic_img" :src="model.topic_img" class="upImg" style="width: 375px;height: 215px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 375px;height: 215px;line-height: 215px"></i>
                </el-upload>
                <span class="tips">建议尺寸：750px * 430px</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('show_state')" :key="'show_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model="model.order_index" style="width:192px"></el-input>
            </el-form-item>
            <el-form-item label="展示浏览量：" prop="view_count1">
                <el-input v-model="model.view_count1" style="width:192px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import config from '@/config'

export default {
    name: 'momentTopicEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                topic_name: '',
                topic_desc: '',
                topic_img: '',
                order_index: '',
                state: '1',
                view_count1: '',
            },
            getObj:{
                url:'/api/admin/momenttopic/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['show_state'],
            rules: {
                topic_name: [
                    {required: true, message: '话题名称不能为空', trigger: 'blur'}
                ],
                topic_desc: [
                    {required: true, message: '话题描述不能为空', trigger: 'blur'}
                ],
                topic_img: [
                    {required: true, message: '话题封面不能为空', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '状态不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "momenttopic",
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/momenttopic/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.topic_img = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        formateData(){
            this.model.state = this.model.state+""
        }
    }
};
</script>